// You can write more code here

import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import LoadingSpinner from '@/game/prefabs/GeneralUI/LoadingSpinner';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';

/* START OF COMPILED CODE */

export default class LoadingPanel extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker_2
    const uIBlocker_2 = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker_2);

    // spinnerContainer
    const spinnerContainer = scene.add.container(512, 384);
    this.add(spinnerContainer);

    // loadingSpinner
    const loadingSpinner = new LoadingSpinner(scene, 0, 0);
    spinnerContainer.add(loadingSpinner);

    this.spinnerContainer = spinnerContainer;

    /* START-USER-CTR-CODE */
    this.scene.events.once('scene-awake', this.create, this);
    /* END-USER-CTR-CODE */
  }

  private spinnerContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  create() {
    const anchor = getAnchorPlugin(this.scene);

    anchor.add(this, {
      width: '100%',
      height: '100%',
    });

    anchor.add(this.spinnerContainer, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
